import { render, staticRenderFns } from "./lohn_list.vue?vue&type=template&id=b3990c6a&scoped=true&"
import script from "./lohn_list.vue?vue&type=script&lang=js&"
export * from "./lohn_list.vue?vue&type=script&lang=js&"
import style0 from "./lohn_list.vue?vue&type=style&index=0&id=b3990c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3990c6a",
  null
  
)

export default component.exports